var e=/[​‌‍﻿­‎‏]/g,n=/[\s ]+/g;function t(r){return r?r.normalize("NFC").replace(e,"").replace(n," ").trim():""}export{t as a};